<template>
  <div v-if="ifLoad">
    <el-row v-if="isChild == 0" type="flex" style="flex-wrap:wrap;" >
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        查看页面基础设置:
      </el-col>
      <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
        <el-button type="primary" size="mini" @click="openDialog(34,0)">查看页面基础设置</el-button>
        <el-button type="primary" size="mini" @click="openDialog(35,0)">查看页面基础样式</el-button>
      </el-col>
    </el-row>
    <el-row type="flex" style="flex-wrap:wrap;" >
      <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
        字段设置:
        <div v-if="isChild == 0">
          行:<el-input-number v-model="fieldTableInfo.row" size="mini" style="width: 100px;" placeholder="3" controls-position="right" ></el-input-number>
        </div>
        <div>
          列:<el-input-number v-model="fieldTableInfo.col" size="mini" style="width: 100px;" placeholder="3" controls-position="right" ></el-input-number>
        </div>
        <el-button type="primary" size="mini" @click="deleteAllField">清除所有字段</el-button>
      </el-col>
      <el-col :xs="24" :sm="24" :md="22" :lg="22" :xl="22">
        <!-- 循环行列生成 表格信息 -->
        <table style="-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;user-select:none;">
          <tr v-for="xhRow in (fieldTableInfo.row)" :key="'row_'+xhRow">
            <template v-for="xhCol in (fieldTableInfo.col)">
              <td v-if="fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_colspan'] != 0" :key="'row_'+xhRow+'_' + xhCol" style="width:300px;border: 1px solid #d2d9e9;" rowspan="1" :colspan="fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_colspan']" class="dragger_td" :row="xhRow" :col="xhCol" @dblclick="toAddField(xhRow,xhCol)">
                <template v-for="(oneField,index) in value.addFieldSet">
                  <div v-if="oneField.row==(xhRow-1) && (oneField.col==(xhCol-1)) " :key="'field_'+index" class="dragger_field" style="display: inline-block;border:1px solid;" >
                    <span @mousedown="e=>addFieldMove(e,oneField)">{{oneField.fieldCnName}}</span>
                    <el-button-group style="">
                      <el-button type="primary" size="mini" title="addFieldSet" icon="el-icon-s-tools" circle @click="openDialog(15,index)"></el-button>
                      <el-button type="primary" size="mini" title="addFieldSet" icon="el-icon-edit" circle @click="openDialog(2,index)"></el-button>
                      <!-- <el-button type="primary" size="mini" icon="el-icon-top" circle @click="toUpChildOne(value.addFieldSet,index)"></el-button>
                      <el-button type="primary" size="mini" icon="el-icon-bottom" style="padding: 7px;" @click="toDownChildOne(value.addFieldSet,index)"></el-button> -->
                      <el-button type="primary" size="mini" icon="el-icon-delete-solid" circle  @click="toDeleteChildOne(value.addFieldSet,index)"></el-button>
                      
                    </el-button-group>
                  </div>
                </template>
                <el-button type="primary" size="mini" style="float:right;" icon="el-icon-s-tools" @click="changRowColSpanType(xhRow,xhCol)" ></el-button>
                <div v-if="fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_type']">
                  <!-- <el-input type="text" v-model="fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_rowspan']" placeholder="3" ><template slot="prepend">行合并</template></el-input> -->
                  <el-input class="prepend_no" type="text" size="mini" style="width:80px;" v-model="fieldTableInfo.rowColSpanInfo['span_'+xhRow+'_'+xhCol+'_colspan']" placeholder="3" @change="colspanChange(xhRow,xhCol)" ><template slot="prepend">列合并</template></el-input>
                  <el-button-group style="">
                  <el-button type="primary" size="mini" @click="addRow(xhRow,1)">+行</el-button>
                  <el-button type="primary" size="mini" @click="addCol(xhCol,1)">+列</el-button>
                  <el-button type="primary" size="mini" @click="deleteRow(xhRow)">行-</el-button>
                  <el-button type="primary" size="mini" @click="deleteCol(xhCol)">列-</el-button>
                  </el-button-group>
                </div>
              </td>
            </template>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-dialog v-if="addDialogFlag"
              title="查看页面字段设置"
              :visible.sync="addDialogFlag"
              width=98%
              top="1vh"
              center
              append-to-body :before-close="handleClose">
      <!-- 添加修改查看页面的 字段设置 -->
      <PageBasicSet v-if="addDialogType==2" v-model="value.addFieldSet[nowFieldIndex].styleSet" :fieldOne="value.addFieldSet[nowFieldIndex]" :ImageList="ImageList" :tableId="value.tableId" :relationTableId="value.relationTableId" :pageId="value.pageId" :basicBlockArr="pageFieldBlockArr" :cssBlockArr="pageFieldCssBlockArr" :type="addDialogType"></PageBasicSet>
      <!-- 查看页面字段基础设置 -->
      <PageBasicSet v-if="addDialogType==15" v-model="value.addFieldSet[nowFieldIndex]" :ImageList="ImageList" :tableId="value.tableId" :relationTableId="value.relationTableId" :pageId="value.pageId" :pageName="value.pageName" :basicBlockArr="pageFieldBasicBlockArr" :cssBlockArr="[]" :isChild="isChild" :type="addDialogType"></PageBasicSet>
      <!-- 查看页面基础设置 -->
      <PageBasicSet v-if="addDialogType==34" v-model="value" :ImageList="ImageList" :tableId="value.tableId" :relationTableId="value.relationTableId" :pageId="value.pageId" :pageName="value.pageName" :basicBlockArr="lookPageBasicBlockArr" :cssBlockArr="[]" :isChild="isChild" :type="addDialogType"></PageBasicSet>
      <!-- 查看页面样式设置 -->
      <PageBasicSet v-if="addDialogType==35" v-model="value.styleSet" :ImageList="ImageList" :tableId="value.tableId" :relationTableId="value.relationTableId" :pageId="value.pageId" :pageName="value.pageName" :basicBlockArr="lookPageBlockArr" :cssBlockArr="lookPageCssBlockArr" :isChild="isChild" :type="addDialogType"></PageBasicSet>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'LookFieldSet',
  props: {
    value: {
      type:Object,
      default(){
        return {}
      }
    },
    ImageList:{
      type:Array
    },
    isChild:{
      type:Number,
      default:0
    }
  },
  data() {
    var that = this;
    var data = {
      //弹出层的打开状态
      addDialogFlag:false,
      addDialogType:0,
      ifLoad:false,
      //表格的大小以及合并信息
      fieldTableInfo:{
        row:0,
        col:0,
        now_col:0,
        now_row:0,
        rowColSpanInfo:{

        },
        popoverType:false
      },
      pageFieldBlockArr:[{blockCnName:"样式设置",
          fieldArr:[{
            cnName:"展现形式",enName:"showStyle",type:1,
            dicList:[{label:"默认样式",value:"1"},{label:"副标题",value:"10"},{label:"轮播图",value:"2"},{label:"纵向标签显示(kw_label_col)",value:"3"},{label:"切换组件",value:"4"},{label:"弹出层组件(默认打开)",value:"5"},{label:"横向标签显示(kw_label_row)",value:"6"},{label:"隐藏不显示",value:"7"},{label:"带背景图片的title",value:"8"},{label:"主标题",value:"9"},{label:"人员头像列表",value:"11"},
            // {label:"单行两列",value:"12"},
            {label:"徽章称号",value:"13"},{label:"图片",value:"14"},{label:"状态聚合样式",value:"15"},{label:"星级评价",value:"16"},{label:"富文本",value:"18"},{label:"进度条",value:"19"},{label:"单行右侧选择",value:"20"},{label:"倒计时",value:"21"},{label:"倒计时(隐藏)",value:"22"},{label:"视频",value:"23"},{label:"音频",value:"24"},{label:"角色看板",value:"25"},{label:"定位组件-图片",value:"26"},{label:"定位组件-内容",value:"27"},{label:"地址选择",value:"28"},{label:"数字加减",value:"29"},{label:"地图地址",value:"30"},{label:"发帖编辑器",value:"31"},{label:"角色栏目",value:"32"},{label:"排课组件",value:"33"},{label:"工作台组件",value:"34"},{label:"周排课组件",value:"35"},{label:"直播流播放",value:"36"},{label:"试题组件",value:"37"},{label:"全景图组件",value:"38"},{label:"二维码",value:"39"},{label:"条码",value:"40"},{label:"盘点框",value:"41"},{label:"扫码框",value:"42"},{label:"对象选择",value:"43"},{label:"多条件插件",value:"44"},{label:"知识图谱",value:"45"},{label:"GIS遥感展示",value:"46"}]
          },{
            cnName:"GIS是否显示统计图",enName:"gisIfShowPie",type:1,filterName:'showStyle',filterValue:'46',filterType:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"地图类型",enName:"mapType",type:1,filterName:'showStyle',filterValue:'30',filterType:1,
            dicList:[{label:"高德",value:"1"},{label:"百度",value:"2"},{label:"GIS天地图",value:"3"}]
          },{
            cnName:"绘制图形类型",enName:"drawingType",type:1,filterName:'showStyle',filterValue:'30',filterType:1,
            dicList:[{label:"点",value:"1"},{label:"海量点",value:"2"},{label:"折线",value:"3"},{label:"多边形",value:"4"},{label:"圆形",value:"5"},{label:"标签",value:"56"}]
          },{
            cnName:"是否绘制数据",enName:"ifDrawingData",type:1,filterName:'showStyle',filterValue:'30',filterType:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"是否只读一次",enName:"ifScanNum",type:1,filterName:'showStyle',filterValue:'42',filterType:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"开始扫码按钮名称",enName:"scanButtonName",type:2,filterName:'showStyle',filterValue:'42',filterType:1
          },{
            cnName:"是否拖动上传",enName:"fileUploadDrag",type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"上传文件类型",enName:"fileType",type:1,
            dicList:[{label:"图片",value:"1"},{label:"录音",value:"2"},{label:"视频",value:"3"},{label:"全部",value:"4"}]
          },{
            cnName:"最大最小值",type:2,filterName:'showStyle',filterValue:'29',filterType:1,
            inputArr:[{cnName:"最小值",enName:"minNumber",placeholder:"1"},
                {cnName:"最大值",enName:"maxNumber",placeholder:"100"}]
          },{
            cnName:"是否显示查看次数",enName:"isShowLook",type:1,filterName:'showStyle',filterValue:'15',filterType:1,
            dicList:[{label:"isShowLook",value:"0"},{label:"隐藏",value:"1"}]
          },{
            cnName:"是否显示收藏次数",enName:"isShowStar",type:1,filterName:'showStyle',filterValue:'15',filterType:1,
            dicList:[{label:"默认显示",value:"0"},{label:"隐藏",value:"1"}]
          },{
            cnName:"图片是否可预览",enName:"imgPreview",type:1,filterName:'showStyle',filterValue:'14',filterType:1,
            dicList:[{label:"不可预览",value:"1"},{label:"可预览",value:"2"},{label:"可预览显示提示",value:"3"}]
          },{
            cnName:"弹出层是否隐藏",enName:"dialogIfHide",type:1,filterName:'showStyle',filterValue:'1,5',filterType:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"下拉框类型",enName:"selectType",type:1,
            dicList:[{label:"box框",value:"1"},{label:"下拉框",value:"2"}]
          },{
            cnName:"下拉框是否可搜索",enName:"filterable",type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"是否自动播放",enName:"ifAutoPlay",type:1,filterName:'showStyle',filterValue:'23,24',filterType:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"播放结束刷新逻辑",enName:"overRefreshType",type:1,filterName:'showStyle',filterValue:'23,24',filterType:1,
            dicList:[{label:"选项卡刷新",value:"1"},{label:"本页刷新",value:"2"}]
          },{
            cnName:"禁用拖动快进",enName:"ifBanFast",type:1,filterName:'showStyle',filterValue:'23,24',filterType:1,
            dicList:[{label:"禁用",value:"1"},{label:"不禁用",value:"2"}]
          },{
            cnName:"是否显示封面及音频文本",enName:"ifShowSentences",type:1,filterName:'showStyle',filterValue:'24',filterType:1,
            dicList:[{label:"显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"是否显示播放进度条",enName:"ifShowSlider",type:1,filterName:'showStyle',filterValue:'24',filterType:1,
            dicList:[{label:"显示",value:"1"},{label:"不显示",value:"2"},{label:"背景音频",value:"3"},{label:"原生组件",value:"4"},{label:"小喇叭",value:"5"}]
          },{
            cnName:"轮播图previous-margin",enName:"plantingPreviousMargin",type:2,filterName:'showStyle',filterValue:'6',filterType:1,
            placeholder:"10rpx"
          },{
            cnName:"轮播图next-margin",enName:"plantingNextMargin",type:2,filterName:'showStyle',filterValue:'6',filterType:1,
            placeholder:"10rpx"
          },{
            cnName:"轮播图圆点提示",enName:"plantingIndicatorDots",type:1,filterName:'showStyle',filterValue:'6',filterType:1,
            dicList:[{label:"默认显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"是否短信校验",enName:"ifPhoneMsgCheck",type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"在第几块显示",enName:"isBlockShow",type:2
          },{
            cnName:"图片位置",enName:"imgPosition",type:1,filterName:'showStyle',filterValue:'2,7',filterType:2,
            dicList:[{label:"无",value:"0"},{label:"背景图片",value:"1"},{label:"上部图片",value:"2"},{label:"左侧图片",value:"3"}]
          },{
            cnName:"字段图标图片",enName:"iconImage",type:3,filterName:'showStyle',filterValue:'2,7',filterType:2
          },{
            cnName:"标题显示类型",enName:"titleNameHide",type:1,filterName:'showStyle',filterValue:'2,7',filterType:2,
            dicList:[{label:"显示name和内容",value:"1"},{label:"不显示name",value:"2"},{label:"name在内容下方",value:"3"}]
          },{
            cnName:"name是否显示冒号(:)",enName:"nameShowIcon",type:1,filterName:'titleNameHide',filterValue:'2',filterType:2,
            dicList:[{label:"默认显示",value:"1"},{label:"不显示",value:"2"}]
          },{
            cnName:"价格单位设置",enName:"priceUnit",type:1,filterName:'showStyle',filterValue:'2,7',filterType:2,
            dicList:[{label:"无",value:""},{label:"￥",value:"￥"},{label:"-",value:"-"}]
          },{
            cnName:"单位字体大小设置",enName:"priceUnitSize",type:2,filterName:'showStyle',filterValue:'2,7',filterType:2, placeholder:'10px'
          },{
            cnName:"单行两列右侧类型",enName:"rightType",type:1,filterName:'showStyle',filterValue:'12',filterType:1,
            dicList:[{label:"按钮",value:"1"}]
          },{
            cnName:"是否显示跳转icon",enName:"jumpIcon",type:1,filterName:'showStyle',filterValue:'2',filterType:2,
            dicList:[{label:"显示",value:"1"}]
          },{
            cnName:"点击事件",enName:"clickType",type:1,
            dicList:[{label:"跳转列表页",value:"3"},{label:"跳转详情页",value:"4"},{label:"点击复制",value:"5"}]
          },{
            cnName:"点击跳转",type:2,
            inputArr:[{cnName:"跳转的对象ID",enName:"clickTableId",placeholder:"跳转的对象ID"},
                {cnName:"跳转的PageID",enName:"clickPageId",placeholder:"跳转的PageID"}]
          }]
      }],
      pageFieldCssBlockArr:[{
        blockCnName:"字段设置",
        // filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"字段外层样式设置",enName:"pageFieldStyleSet",type:1,filterName:'showStyle',filterValue:'9,39,40',filterType:2
        },{
          cnName:"字段name样式设置",enName:"pageFieldNameStyleSet",type:1,filterName:'showStyle',filterValue:'9,39,40',filterType:2
        },{
          cnName:"副标题字段name外层样式设置",enName:"pageFieldNameBoxStyleSet",type:1,filterName:'showStyle',filterValue:'10',filterType:1
        },{
          cnName:"字段value样式设置",enName:"pageFieldValueStyleSet",type:1
        },{
          cnName:"字段循环层样式设置",enName:"pageForFieldStyleSet",type:1,filterName:'showStyle',filterValue:'9',filterType:2
        },{
          cnName:"图片样式设置",enName:"pageFieldImageStyleSet",type:1,filterName:'showStyle',filterValue:'8,39,40',filterType:2
        },{
          cnName:"单行两列最外层样式设置",enName:"pageFieldDoubleBoxStyleSet",type:1,filterName:'showStyle',filterValue:'12',filterType:1
        },{
          cnName:"字段dicList样式设置",enName:"pageFieldValueDicStyleSet",type:1
        }]
      },{
        blockCnName:"状态聚合样式设置",
        filterName:'showStyle',filterValue:'15',filterType:1,
        buttonArr:[{
          cnName:"查看次数样式设置",enName:"pageFieldLookStyleSet",type:1
        },{
          cnName:"收藏次数样式设置",enName:"pageFieldCollectionStyleSet",type:1
        },{
          cnName:"购买次数样式设置",enName:"pageFieldBuyStyleSet",type:1
        }]
      },{
        blockCnName:"tabs组件样式设置",
        filterName:'showStyle',filterValue:'6',filterType:1,
        buttonArr:[{
          cnName:"一级整体样式设置",enName:"pageFieldOneBoxStyleSet",type:1
        },{
          cnName:"一级tabs组件样式设置",enName:"pageFieldOneTabsStyleSet",type:1
        },{
          cnName:"一级tab未选中样式设置",enName:"pageFieldOneTabDefaultStyleSet",type:1
        },{
          cnName:"一级tab选中样式设置",enName:"pageFieldOneTabCheckStyleSet",type:1
        },{
          cnName:"二级整体样式设置",enName:"pageFieldTwoBoxStyleSet",type:1
        },{
          cnName:"二级tabs组件样式设置",enName:"pageFieldTwoTabsStyleSet",type:1
        },{
          cnName:"二级tab未选中样式设置",enName:"pageFieldTwoTabDefaultStyleSet",type:1
        },{
          cnName:"二级tab选中样式设置",enName:"pageFieldTwoTabCheckStyleSet",type:1
        }]
      },{
        blockCnName:"轮播样式设置",
        filterName:'showStyle',filterValue:'2',filterType:1,
        buttonArr:[{
          cnName:"轮播外层的样式设置",enName:"pageFieldRotationBoxStyleSet",type:1
        },{
          cnName:"轮播内容的样式设置",enName:"pageFieldRotationCommonStyleSet",type:1
        }]
      },{
        blockCnName:"头像样式设置",
        filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"老师字段外层样式设置",enName:"listFieldPhotoSrcStyleSet",type:1
        },{
          cnName:"有头像的老师字段样式设置",enName:"listFieldNoPhotoSrcStyleSet",type:1
        },{
          cnName:"有头像的老师头像样式设置",enName:"listFieldTeacherStyleSet",type:1
        },{
          cnName:"无头像的老师字段样式设置",enName:"listFieldPhotoSrcPhotoStyleSet",type:1
        }]
      },{
        blockCnName:"工作台组件样式设置",
        filterName:'showStyle',filterValue:'34',filterType:1,
        buttonArr:[{
          cnName:"看板外层样式设置",enName:"kbNameValueBoxStyleSet",type:1
        },{
          cnName:"看板名称样式设置",enName:"kbNameStyleSet",type:1
        },{
          cnName:"看板值样式设置",enName:"kbValueStyleSet",type:1
        }]
      }],
      pageFieldBasicBlockArr:[{
        blockCnName:"基础设置",
        fieldArr:[{
            cnName:"字段or值插件",enName:"fieldOrPlug",type:1,ifMust:1,
            dicList:[{label:"主表字段",value:1,ifHide:0},{label:"弹出层字段",value:2,ifHide:0},{label:"弹出层值插件",value:3,ifHide:0}]
          },{
            cnName:"主表字段",enName:"fieldObj",type:10,placeholder:'',ifMust:1,filterJson:{
              mainTableId:that.tableId,
              filterType:"0!25!26!27!28"
            },filterName:'fieldOrPlug',filterValue:'1',filterType:1
          },{
            cnName:"弹出层字段",enName:"fieldObj",type:10,placeholder:'',ifMust:1,filterJson:{
              mainRelationTableId:that.tableId,
              filterType:"0!25!26!27!28"
            },filterName:'fieldOrPlug',filterValue:'2',filterType:1
          },{
            cnName:"值插件",enName:"valuePlugIdJson",type:17,ifMust:1,filterName:'fieldOrPlug',filterValue:'3',filterType:1
          },{
            cnName:"中文名称",enName:"fieldCnName",type:2,placeholder:'',ifMust:1
          },{
            cnName:"自定义别名",enName:"zdyAliasName",type:2,placeholder:''
          },{
            cnName:"是否必填",enName:"ifMust",type:1,
            dicList:[{label:"非必填",value:0},{label:"必填",value:1}]
          },{
            cnName:"是否可修改",enName:"ifUpdate",type:1,
            dicList:[{label:"是",value:1},{label:"否",value:0}]
          },{
            cnName:"隐藏显示清值",enName:"ifChangeClean",type:1,
            dicList:[{label:"是",value:0},{label:"否",value:1}]
          },{
            cnName:"展现形式",enName:"showType",type:1,filterName:'fieldRole',filterValue:'1,9,10',filterType:1,
            dicList:[{label:"文本",value:0},{label:"文本域",value:1}]
          },{
            cnName:"展现形式",enName:"showType",type:1,filterName:'fieldRole',filterValue:'2',filterType:1,
            dicList:[{label:"编辑器",value:0},{label:"签字版",value:1}]
          },{
            cnName:"默认显示值",enName:"dicChildShow",type:15,filterEnName:'dicParId',filterName:'dicParId',filterType:3
          },{
            cnName:"默认选中值",enName:"dicDefaultSelect",type:15,dicFilterEnName:"dicChildShow",multipleEnName:"fieldRole",filterEnName:'dicParId',filterName:'dicParId',filterType:3
          },{
            cnName:"展现形式",enName:"selectStyle",type:1,filterName:'fieldRole',filterValue:'16,17',filterType:1,
            dicList:[{label:"下拉框",value:0},{label:"选择框",value:1}]
          },{
            cnName:"日期格式",enName:"dateType",type:1,ifMust:1,
            dicList:[{label:"yyyy-MM-dd",value:'yyyy-MM-dd'},{label:"yyyy/MM/dd",value:'yyyy/MM/dd'},{label:"yyyyMMdd",value:"yyyyMMdd"},{label:"yyyy-MM-dd HH:mm:ss",value:"yyyy-MM-dd HH:mm:ss"},{label:"yyyy-MM-dd HH:mm",value:"yyyy-MM-dd HH:mm"},{label:"yyyy",value:"yyyy"},{label:"yyyy-MM",value:"yyyy-MM"}],filterName:'fieldRole',filterValue:'14,',filterType:1
          },{
            cnName:"时段格式",enName:"dateType",type:1,ifMust:1,
            dicList:[{label:"HH:mm",value:"HH:mm"},{label:"HH:mm:ss",value:"HH:mm:ss"}],filterName:'fieldRole',filterValue:'15',filterType:1
          },{
            cnName:"附件类型",enName:"fileType",type:2,filterName:'fieldRole',filterValue:'18,19',filterType:1,placeholder:'.png,.jpg,.pdf'
          },{
            cnName:"附件大小",enName:"fileSize",type:2,filterName:'fieldRole',filterValue:'18,19',filterType:1,placeholder:'M'
          },{
            cnName:"附件个数",enName:"fileNum",type:2,filterName:'fieldRole',filterValue:'19',filterType:1,placeholder:'数字'
          },{
            cnName:"是否只预览",enName:"ifonlyPreView",type:1,filterName:'fieldRole',filterValue:'18,19',filterType:1,
            dicList:[{label:"否",value:0},{label:"是",value:1}]
          },{
            cnName:"是否可新增",enName:"ifCanAdd",type:1,filterName:'fieldRole',filterValue:'20,21,22',filterType:1,
            dicList:[{label:"否",value:0},{label:"是",value:1}]
          },{
            cnName:"添加页面",enName:"addPageId",type:14,filterName:'ifCanAdd',filterValue:'1',filterType:1,
            filterEnName:'fieldObj',filterFieldEnName:'relationTableId',filterPageTypeValue:'5',ifZdyAddPage:1,addPageName:"fieldCnName"
          },{
            cnName:"添加形式",enName:"addStyle",type:1,ifMust:1,
            dicList:[{label:"选择对象添加",value:1},{label:"默认全部添加",value:2},{label:"点击+号添加",value:3}],filterName:'fieldRole',filterValue:'21',filterType:1
          },{
            cnName:"添加形式",enName:"addStyle",type:1,ifMust:1,
            dicList:[{label:"选择对象添加",value:1},{label:"默认全部添加",value:2}],filterName:'fieldRole',filterValue:'20,22',filterType:1
          },{
            cnName:"选择形式",enName:"chooseType",type:1,ifMust:1,
            dicList:[{label:"弹出层",value:0},{label:"下拉树",value:1},{label:"下拉框",value:2}],filterName:'addStyle',filterValue:'1,2',filterType:1
          },{
            cnName:"外键字段",enName:"dialogFieldObj",type:10,placeholder:'',ifMust:1,filterEnName:'fieldObj',filterFieldEnName:'relationTableId',filterFieldRole:'20!22',filterName:['addStyle','fieldRole'],filterValue:['1,2','21'],filterType:[1,1]
          },{
            cnName:"弹出层页面",enName:"pageDialog",type:14,ifMust:1,filterName:'chooseType',filterValue:'0,2',filterType:1,filterEnName:'dialogFieldObj',filterFieldEnName:'relationTableId',filterPageTypeValue:'15',ifZdyAddPage:1,addPageName:"fieldCnName"
          },{
            cnName:"下拉树",enName:"pageDialog",type:14,ifMust:1,filterName:'chooseType',filterValue:'1',filterType:1,filterEnName:'dialogFieldObj',filterFieldEnName:'relationTableId',filterPageTypeValue:'16',ifZdyAddPage:1,addPageName:"fieldCnName"
          },{
            cnName:"前置条件",enName:"tjIdJson",type:6,placeholder:''
          },{
            cnName:"默认值",enName:"defaultValIdJson",type:4, placeholder:'',filterName:'fieldOrPlug',filterValue:'1',filterType:1
          },{
            cnName:"字段描述",enName:"fieldDescribe",type:5,placeholder:''
          },{
            cnName:"自定义sql",enName:"customSql",type:5,placeholder:''
          },{
            cnName:"子表格页面",enName:"showFieldArr",type:16,ifMust:1,placeholder:'',filterName:['addStyle','pageDialog'],filterValue:['3',''],filterType:[1,3],filterOrAnd:'or',filterEnName:'dialogFieldObj',filterFieldEnName:'relationTableId',filterTableIdEnName:""
          }
        ]
      }],
      lookPageBasicBlockArr:[{
        blockCnName:"基础设置",
        fieldArr:[{
          cnName:"展现形式",enName:"addShowStyle",type:1,
          dicList:[{label:"普通",value:0},{label:"下拉块",value:1}]
        },{
          cnName:"保存并新建按钮是否显示",enName:"ifShowSaveNewBtn",type:1,
          dicList:[{label:"是",value:0},{label:"否",value:1}],filterName:'pageType',filterValue:'5',filterType:1
        },{
          cnName:"新建是否清空页面",enName:"ifCleanPage",type:1,
          dicList:[{label:"是",value:0},{label:"否",value:1}],filterName:'pageType',filterValue:'5',filterType:1
        },{
          cnName:"触发器执行顺序",enName:"triggerOrder",type:1,
          dicList:[{label:"主表先走",value:0},{label:"子表先走",value:1}]
        },{
          cnName:"显示块位置",enName:"blockLayOut",type:1,
          dicList:[{label:"居下",value:0},{label:"居上",value:1}]
        },{
          cnName:"是否走触发器",enName:"ifTrigger",type:1,
          dicList:[{label:"是",value:0},{label:"否",value:1}]
        }
        // ,{
        //   cnName:"保存成功提示信息",enName:"successMesage",type:5
        // }
        ]
      },{
        blockCnName:"自定义设置",
        fieldArr:[{
          cnName:"自定义joinSQL",enName:"zdyJoinSql",type:5,placeholder:''
        },{
          cnName:"自定义vuejs",enName:"customVueJs",type:5,placeholder:''
        },{
          cnName:"自定义页面保存限制",enName:"saveValiadSet",type:9,placeholder:'',
          fieldArr:[{
            cnName:"提示信息",enName:"alertContent",type:2,placeholder:''
          },{
            cnName:"sql",enName:"saveLimitSql",type:5,placeholder:'',remark:'存储过程：call testPro(#{ID},#{CONTENT,mode=OUT,jdbcType=NVARCHAR}),ID 作为IN参数传入当前页面主的ID,OUT参数名固定为CONTENT(提示信息),CONTENT为空可以保存,CONTENT可以为JSON例如(保存成功):CONTENT=zdyResult:{"ID":1,"CONTENT":"保存成功自定义提示内容"},保存失败:{"ID":0,"CONTENT":"保存失败自定义提示内容"},CONTENT也可以直接放提示内容例如(保存成功):zdyResult:保存成功;(保存失败):zdyResult:保存失败,有并且提相应信息;其他：直接编写查询sql(能查询出结果则表示不能进行保存);'
          }]
        }]
      }],
      lookPageBlockArr:[{
        blockCnName:"自定义设置",
        fieldArr:[{
          cnName:"返回方式",enName:"prevIfHome",type:1,
          dicList:[{label:"跳转首页",value:1},{label:"默认返回",value:2}]
        },{
          cnName:"返回页码",enName:"prevHistoryNum",type:2,placeholder:''
        },{
          cnName:"页面点击js",enName:"kwLookPageBoxClickJs",type:5,placeholder:''
        }]
      }],
      lookPageCssBlockArr:[{
        blockCnName:"字段设置",
        // filterName:'showStyle',filterValue:'11',filterType:1,
        buttonArr:[{
          cnName:"查看页面整体EL_ROW样式设置",enName:"lookCommonRowBoxStyleSet",type:1
        },{
          cnName:"查看页面整体样式设置",enName:"lookCommonStyleSet",type:1
        }]
      }]
    };
    console.log("that.value.pageType================================",that.value.pageType);
    if(that.value.pageType == 7 || that.value.pageType == 11) {
      data.pageFieldBasicBlockArr[0].fieldArr.push({
        cnName:"历史信息是否可修改",enName:"historyifUpdate",type:1,
        dicList:[{label:"是",value:1},{label:"否",value:0}]
      });
      data.pageFieldBasicBlockArr[0].fieldArr.push({
        cnName:"为空时显示为默认值",enName:"ifNullShowDefVal",type:1,
        dicList:[{label:"是",value:1},{label:"否",value:0}]
      });
      data.pageFieldBasicBlockArr[0].fieldArr.push({
        cnName:"是否显示为默认值",enName:"ifShowDefVal",type:1,
        dicList:[{label:"是",value:1},{label:"否",value:0}]
      });
    }
    return data;
  },
  created() {
    var that = this;
    //获取当前的行列设置 根据字段
    if(that.value.addFieldSet) {
      var maxRow = 0;
      var maxCol = 0;
      that.value.addFieldSet.forEach(element=>{
          if(element.row > maxRow) {
            maxRow = element.row;
          }
          if(element.col > maxCol) {
            maxCol = element.col;
          }
          if(element.colSpan > 1) {
            that.$set(that.fieldTableInfo.rowColSpanInfo,'span_'+(element.row+1)+'_'+(element.col+1)+'_colspan',element.colSpan);
            for (let index = 1; index < element.colSpan; index++) {
              that.$set(that.fieldTableInfo.rowColSpanInfo,'span_'+(element.row+1)+'_'+(element.col+1+index)+'_colspan',0);
            }
          }
      })
      
      that.fieldTableInfo.row = maxRow+1;
      that.fieldTableInfo.col = maxCol+1;
    }
    console.log("that.fieldTableInfo======================",that.fieldTableInfo);
    that.ifLoad = true;
  },
  mounted() {
    
  },
  beforeDestroy(){
    
  },
  destroyed(){

  },
  watch:{
  },
  computed:{
  },
  components: {
    CommonStyleSet:resolve => require(['@/components/page/pageSet/CommonStyleSet.vue'], resolve),
    OneFieldSet:resolve => require(['@/components/page/pageSet/OneFieldSet.vue'], resolve),
    PageBasicSet:resolve => require(['@/components/page/pageSet/PageBasicSet.vue'], resolve)
  },
  methods: {
    openDialog(type,index){
      this.nowFieldIndex = index;
      this.addDialogType = type;
      this.addDialogFlag = true;
    },
    changRowColSpanType(row,col){
      var that = this;
      that.$set(that.fieldTableInfo.rowColSpanInfo,'span_'+row+'_'+col+'_type',!that.fieldTableInfo.rowColSpanInfo['span_'+row+'_'+col+'_type']);
      if(!that.fieldTableInfo.rowColSpanInfo['span_'+row+'_'+col+'_colspan']) {
        that.$set(that.fieldTableInfo.rowColSpanInfo,'span_'+row+'_'+col+'_colspan',1);
      }
      console.log("that.fieldTableInfo===============",that.fieldTableInfo,row,col);
      // that.fieldTableInfo.rowColSpanInfo['span_'+row+'_'+col+'_type'] = !that.fieldTableInfo.rowColSpanInfo['span_'+row+'_'+col+'_type']
      // that.fieldTableInfo.rowColSpanInfo['span_'+row+'_'+col+'_type']?!that.fieldTableInfo.rowColSpanInfo['span_'+row+'_'+col+'_type']:true;
    },
    colspanChange(row,col) {
      var that = this;
      var nowColspan = that.fieldTableInfo.rowColSpanInfo['span_'+row+'_'+col+'_colspan'];
      console.log("nowColspan===============",nowColspan);
      //把后边的 列的colspan设置为0
      if(nowColspan>1) {
        for (let index = 1; index < nowColspan; index++) {
          that.$set(that.fieldTableInfo.rowColSpanInfo,'span_'+row+'_'+(col+index)+'_colspan',0);
        }
      } else if(nowColspan==1) {
        var flag = true;
        for (let index = col+1; index <= that.fieldTableInfo.col; index++) {
          if(that.fieldTableInfo.rowColSpanInfo['span_'+row+'_'+(index)+'_colspan'] == 0 && flag) {
            that.$set(that.fieldTableInfo.rowColSpanInfo,'span_'+row+'_'+(index)+'_colspan',1);
          } else {
            flag = false;
          }
        }
      } else {
        that.$set(that.fieldTableInfo.rowColSpanInfo,'span_'+row+'_'+col+'_colspan',1);
      }
      // that.$set(that.fieldTableInfo.rowColSpanInfo,'span_'+row+'_'+col+'_type',!that.fieldTableInfo.rowColSpanInfo['span_'+row+'_'+col+'_type']);
      //合并单元格时,切换元素的 rowSpan和colSpan 以及位置
      that.value.addFieldSet.forEach(oneField=>{
        if(oneField.row==(row-1) && (oneField.col>=(col-1) && oneField.col<=(col-1)+(nowColspan?(nowColspan-1):0))){
          oneField.row = (row-1);
          oneField.col = (col-1);
          oneField.rowSpan = 1;
          oneField.colSpan = nowColspan;
        }
      })
    },
    addFieldMove(e,fieldOne){
      var that = this;
      console.log("e==========================",e,fieldOne)
      let odiv = $(e.target).closest(".dragger_field");        //获取目标元素
      // var clone = $(odiv).clone();
      $(odiv).css("position","fixed");
      //算出鼠标相对元素的位置
      // let disX = e.clientX - odiv.offsetLeft;
      // let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = (e)=>{       //鼠标按下并移动的事件
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          let left = e.clientX// - disX;    
          let top = e.clientY// - disY;
          
          //绑定元素位置到positionX和positionY上面
          // this.positionX = top;
          // this.positionY = left;
          console.log("left==================",left,top);
          //移动当前元素
          $(odiv).css("left",(left+10) + 'px');
          $(odiv).css("top",(top+10) + 'px');
          // clone.style.left = left + 'px';
          // clone.style.top = top + 'px';
      };
      document.onmouseup = (e) => {
          $(odiv).css("position","static");
          var tmpTd = $(e.target).closest(".dragger_td");
          if(tmpTd && tmpTd.attr("row") >= 0 && tmpTd.attr("col") >= 0) {
            console.log("tmpTd============================",tmpTd,tmpTd.attr("row"),tmpTd.attr("col"));
            fieldOne.row = tmpTd.attr("row")-1;
            fieldOne.col = tmpTd.attr("col")-1;
            //调用切换字段顺序 根据字段中的 row 和 col
            that.changeAddFieldSetOrder();
          }
          document.onmousemove = null;
          document.onmouseup = null;
      };
    },
    //根据在表格中的下标位置切换 字段的排序
    changeAddFieldSetOrder(){
      var addFieldSet = this.value.addFieldSet;
      var temp;//用于交换的中间变量(建议在这里定义，否则在for循环里定义会降低程序效率)
      for (var i = 1; i < addFieldSet.length; i++) {
        for (var j = 0; j < addFieldSet.length - i; j++) {
          if (addFieldSet[j].row > addFieldSet[j+1].row || (addFieldSet[j].row ==addFieldSet[j+1].row && addFieldSet[j].col>addFieldSet[j+1].col)) {
            temp = addFieldSet[j];//三步交换
            addFieldSet[j] = addFieldSet[j+1];
            addFieldSet[j+1] = temp;
          }
        }
      }
      console.log("changeAddFieldSetOrder================", this.value.addFieldSet);
    },
    toAddField(row,col){
      var that = this;
      var pageFieldBasicBlockArr = that.pageFieldBasicBlockArr;
      var newFieldJson = {styleSet:{}};
      pageFieldBasicBlockArr[0].fieldArr.forEach(element=>{
        if(element.type == 2) {
          newFieldJson[element.enName] = "";
        } else if(element.type == 4 || element.type == 17) {
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            valuePlugId:0
          };
        } else if(element.type == 6){
          newFieldJson[element.enName] = {
            nameStr:'',
            resultStr:'',
            tjPlugId:0
          };
        } else {
          newFieldJson[element.enName] = null;
        }
        newFieldJson.row = row-1;
        newFieldJson.col = col-1;
        newFieldJson.rowSpan = 1;
        newFieldJson.colSpan = 1;
      })
      newFieldJson.fieldOrPlug = 1;
      console.log("newFieldJson========================",newFieldJson);
      that.value.addFieldSet.push(newFieldJson);
      that.changeAddFieldSetOrder();
    },
    handleClose(done){
      var that = this;
      var mustFlag = true;
      var message = "";
      //字段基础设置
      if(that.addDialogType==15) {
        var value = that.value.addFieldSet[that.nowFieldIndex];
        that.pageFieldBasicBlockArr.forEach(blockOne=>{
          blockOne.fieldArr.forEach(fieldOne=>{
            if(fieldOne.ifMust == 1 && ((!fieldOne.filterName || (fieldOne.filterType==1 && (','+fieldOne.filterValue+',').indexOf(','+value[fieldOne.filterName]+',')>=0) || (fieldOne.filterType==2 && (','+fieldOne.filterValue+',').indexOf(','+value[fieldOne.filterName]+',')==-1) || (fieldOne.filterType==3 && value[fieldOne.filterName])))){
              console.log("that.value[fieldOne.enName]====================",fieldOne.cnName,fieldOne,value,value[fieldOne.enName],(!value[fieldOne.enName]),typeof(value[fieldOne.enName]));
              if(value[fieldOne.enName] || (typeof(value[fieldOne.enName])=="number" && value[fieldOne.enName] >= 0)) {
              } else {
                mustFlag = false;
                message+=(message!=""?",":"")+fieldOne.cnName
              }
            }
          })
        })
      }
      if(mustFlag) {
        done();
      } else {
        alert("请填写必填项:"+message);
      }
    },
    /**
     * 删除字段
     */
    toDeleteChildOne(fieldList,index){
      fieldList.splice(index,1);
      this.$forceUpdate();
    },
    deleteAllField(){
      this.value.addFieldSet = [];
    },
    addRow(xhRow,num){
      this.fieldTableInfo.row = this.fieldTableInfo.row+num;
      var addFieldSet = this.value.addFieldSet;
      for (var i = 0; i < addFieldSet.length; i++) {
        var tmpOne = addFieldSet[i];
        if(tmpOne.row >= xhRow) {
          tmpOne.row = tmpOne.row + num;
        }
      }
    },
    deleteRow(xhRow){
      this.fieldTableInfo.row = this.fieldTableInfo.row-1;
      var addFieldSet = this.value.addFieldSet;
      for (var i = addFieldSet.length - 1; i >= 0; i--) {
        var tmpOne = addFieldSet[i];
        if(tmpOne.row+1 == xhRow) {
          addFieldSet.splice(i, 1);
        }
      }
    },
    addCol(xhCol,num){
      this.fieldTableInfo.col = this.fieldTableInfo.col+num;
      var addFieldSet = this.value.addFieldSet;
      for (var i = 0; i < addFieldSet.length; i++) {
        var tmpOne = addFieldSet[i];
        if(tmpOne.col >= xhCol) {
          tmpOne.col = tmpOne.col + num;
        }
      }
    },
    deleteCol(xhCol){
      this.fieldTableInfo.col = this.fieldTableInfo.col-1;
      var addFieldSet = this.value.addFieldSet;
      for (var i = addFieldSet.length - 1; i >= 0; i--) {
        var tmpOne = addFieldSet[i];
        if(tmpOne.col+1 == xhCol) {
          addFieldSet.splice(i, 1);
        }
      }
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.prepend_no .el-input-group__prepend{
  padding:0px !important;
}
</style>
